import React from 'react';

interface PrivacyPolicyScreenProps {
    onClose: () => void;
}

const PrivacyPolicyScreen: React.FC<PrivacyPolicyScreenProps> = ({ onClose }) => {
    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-80 z-50 flex justify-center items-center p-4"
            aria-modal="true"
            role="dialog"
        >
            <div className="bg-white dark:bg-slate-800 rounded-lg shadow-2xl p-6 w-full max-w-3xl h-full max-h-[90vh] flex flex-col animate-fade-in">
                <div className="flex justify-between items-center mb-4 border-b border-gray-200 dark:border-slate-700 pb-4">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Política de Privacidade</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-slate-300">
                        <i className="fas fa-times text-2xl"></i>
                    </button>
                </div>
                
                <div className="prose dark:prose-invert overflow-y-auto pr-4 text-gray-600 dark:text-slate-300">
                    <p><strong>Última atualização:</strong> 08 de Novembro de 2025</p>
                    
                    <p>Bem-vindo à nossa plataforma. A sua privacidade é importante para nós. Esta política de privacidade explica como as suas informações pessoais são coletadas, usadas e divulgadas por esta aplicação.</p>

                    <h4>1. Coleta de Informações</h4>
                    <p>Nós coletamos informações que você nos fornece diretamente, como quando você cria uma conta. As informações que coletamos incluem:</p>
                    <ul>
                        <li>Nome e Sobrenome</li>
                        <li>Endereço de e-mail</li>
                        <li>Senha (armazenada de forma segura usando hash)</li>
                    </ul>

                    <h4>2. Uso das Informações</h4>
                    <p>As informações que coletamos são usadas para:</p>
                    <ul>
                        <li>Fornecer, operar e manter nossa plataforma;</li>
                        <li>Melhorar, personalizar e expandir nossa plataforma;</li>
                        <li>Entender e analisar como você usa nossa plataforma;</li>
                        <li>Permitir o salvamento do seu progresso e histórico de simulados.</li>
                    </ul>

                    <h4>3. Armazenamento de Dados</h4>
                    <p>Todos os dados do usuário, incluindo informações de perfil e progresso nos simulados, são armazenados em um banco de dados usando tecnologias seguras. Nenhum dado pessoal é transmitido ou armazenado em servidores externos aos nossos.</p>

                    <h4>4. Compartilhamento de Informações</h4>
                    <p>Nós não compartilhamos suas informações pessoais com terceiros.</p>

                    <h4>5. Segurança</h4>
                    <p>Tomamos medidas razoáveis para proteger suas informações. As senhas são "hasheadas" (um processo de criptografia unidirecional) antes de serem salvas no armazenamento do banco de dados, o que significa que sua senha real nunca é armazenada.</p>
                    
                    <h4>6. Seus Direitos</h4>
                    <p>Todos os dados são armazenados em um banco de dados, e você pode solicitar remover permanentemente todos os seus dados da aplicação.</p>

                    <h4>7. Alterações a esta Política</h4>
                    <p>Podemos atualizar nossa Política de Privacidade de tempos em tempos. Iremos notificá-lo sobre quaisquer alterações, publicando a nova Política de Privacidade nesta página.</p>
                </div>
                 <div className="mt-6 text-right border-t border-gray-200 dark:border-slate-700 pt-4">
                    <button
                        onClick={onClose}
                        className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-6 rounded-lg transition-colors"
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyScreen;